import React, { Fragment, useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { useLocation } from "react-router-dom";
import useSideMenu from "../../hooks/useSideMenu";
import { horizontalmenusticky } from "../../spruha/data/Switcherdata/Switcherdata";
import useSize from "../../hooks/useScreenSize";

const SideBar = ({ menu }) => {
  let location = useLocation();
  const { windowSize } = useSize();
  // Initialize the custom hook
  const { menuItemsState, clearMenuActive, updateMenuItems, sidebarLinks, sideMenuLogo } = useSideMenu(menu);
  const [currentLocation, setCurrentLocation] = useState("");

  useEffect(() => {
    updateMenuItems(menu);
    const mainContent = document.querySelector(".main-content");
    mainContent.addEventListener("click", mainContentClickFn);
    return () => {
      mainContent.removeEventListener("click", mainContentClickFn);
    };
  }, [location]);

  useEffect(() => {
    if (currentLocation !== location.pathname && windowSize[0] < 992) {
      setCurrentLocation(location.pathname);
      document.querySelector("body")?.classList.remove("main-sidebar-show");
    }
  }, [location.pathname]);

  // location
  useEffect(() => {
    if (document.body.classList.contains("horizontalmenu") && window.innerWidth >= 992) {
      clearMenuActive();
    }
  }, []);

  //  In Horizontal When we click the body it should we Closed
  // eslint-disable-next-line react-hooks/exhaustive-deps
  function mainContentClickFn() {
    if (document.body.classList.contains("horizontalmenu") && window.innerWidth >= 992) {
      clearMenuActive();
    }
  }

  // //Hover effect
  function Onhover() {
    if (document.querySelector(".main-body")) {
      if (document.querySelector(".main-body").classList.contains("main-sidebar-hide"))
        document.querySelector(".main-body").classList.add("main-sidebar-open");
    }
  }

  function Outhover() {
    if (document.querySelector(".main-body")) {
      document.querySelector(".main-body").classList.remove("main-sidebar-open");
    }
  }

  return (
    <Fragment>
      <div className="sticky " style={{ marginBottom: "-64px" }} onScroll={horizontalmenusticky()}>
        <div className="main-menu main-sidebar main-sidebar-sticky side-menu">
          <div className="main-container-1 active main-sidebar-header">
            <Scrollbars options={{ removeTrackXWhenNotUsed: true }} className="hor-scroll" style={{ position: "absolute" }}>
              {sideMenuLogo}

              <div className="main-body-1 main-sidebar-body" onMouseOver={() => Onhover()} onMouseOut={() => Outhover()}>
                <div className="slide-left " id="slide-left">
                  <i className="fe fe-chevron-left"></i>
                </div>

                <ul className="menu-nav nav" style={{ marginLeft: "0px" }}>
                  {sidebarLinks(menuItemsState)}
                </ul>

                <div className="slide-right" id="slide-right">
                  <i className="fe fe-chevron-right"></i>
                </div>
              </div>
            </Scrollbars>
          </div>
        </div>
      </div>
      <div className="jumps-prevent" style={{ paddingTop: "64px" }}></div>
    </Fragment>
  );
};

export default SideBar;
